import isArrayHasItems from "web/utils/data/validator/array/isArrayHasItems";

export default (quote, full) => {
  switch (true) {
    case Boolean(quote && quote.parent_product_data): {
      const attributes = isArrayHasItems(
        quote.parent_product_data.super_attributes
      )
        ? quote.parent_product_data.super_attributes.reduce(
            (result, attribute) => {
              const keys = Object.keys(attribute);
              const key = isArrayHasItems(keys) ? keys[0] : null;
              const value = key ? attribute[key] : null;
              return key && value
                ? [
                    ...result,
                    {
                      attribute: key,
                      value: full[key],
                    },
                  ]
                : result;
            },
            []
          )
        : null;
      return [
        full.image === "no_selection"
          ? quote.parent_product_data.image
          : full.image,
        full.name,
        quote.parent_product_data.url_key,
        full && full.main_category_id,
        attributes,
        full && !!full.can_buy_multiple,
      ];
    }
    case Boolean(full): {
      return [
        full.small_image,
        full.name,
        full.url_key,
        full.main_category_id,
        null,
        full.can_buy_multiple,
      ];
    }
    default: {
      return [];
    }
  }
};
